import { Component, OnInit, Input } from '@angular/core';
import { Experience, SchedaIntense} from '../../core';

@Component({
  selector: 'app-esperienzashare-main-header',
  templateUrl: './esperienzashare-main-header.component.html'
})
export class EsperienzaShareMainHeaderComponent implements OnInit {

  @Input() esperienza: Experience;
  constructor() { 
  }

  ngOnInit() {
  }

}
